import Image from 'next/image'
import styled from 'styled-components'

import { MediaAndContentLayout } from '@/components/pages/gutshot/MediaAndContentLayout'
import { Button } from '@/components/shared/Button'

import { trackCtaClick } from '@/lib/gtm/gtmV2'

const StyledContent = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  max-width: 472px;
  gap: 16px;

  h4 {
    font-family: ${(p) => p.theme.v2.font.nantes};
    font-size: 46px;
    line-height: 64px;
    margin: 0;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: 34px;
      line-height: 48px;
    }
  }

  p {
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
    margin: 0;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.s.lineHeight};
      margin: 0;
    }
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    gap: 12px;
  }
`

const handleOnClick = (label: string) => {
  trackCtaClick('gut_shot', label)
}

export const GutShotWhatIsZoeSection = () => {
  return (
    <MediaAndContentLayout
      content={
        <StyledContent>
          <h4>What is ZOE?</h4>
          <p>
            We&apos;re the gut health experts helping you to transform your health with our personalised approach to
            nutrition.
          </p>
          <p>Join over 120,000 members who have mastered a new way of eating, starting with our at-home test kit.</p>
          <Button
            url="/"
            text="Learn more"
            withArrow
            style="primary"
            target="_blank"
            onClick={() => handleOnClick('Learn more')}
          />
        </StyledContent>
      }
      orientation="left"
      media={<Image src="/assets/img/gutshot/what-is-zoe.jpg" width={670} height={670} alt="Michelle loving life." />}
    />
  )
}
